import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-sales-volume",
  templateUrl: "./sales-volume.component.html",
  styleUrls: ["./sales-volume.component.scss"],
})
export class SalesVolumeComponent implements OnInit {
  searchValue = "";
  subMolecule: boolean = true;

  constructor() {}

  ngOnInit(): void {}

  searchMolecule() {}

  clearFilter() {}
}
